<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <img
          src=""
          alt=""
        >
        <!-- <h2 class="brand-text text-primary ml-1">{{ $t("Diko Therapy") }}</h2> -->
      </b-link>
      <!-- /Brand logo-->
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->
      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t("Welcome to DIKO 👋") }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t("Please Login") }}
          </b-card-text>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              ref="loginForm"
              class="auth-login-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- identifier (email or phone) -->
              <b-form-group
                :label="$t('Phone Number or Email')"
                label-for="login-identifier"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Phone Number or Email')"
                  rules="required"
                >
                  <b-form-input
                    id="login-identifier"
                    v-model="identifier"
                    :state="errors.length > 0 ? false : null"
                    name="login-identifier"
                    :placeholder="$t('Enter your phone number or email...')"
                  />
                  <small class="text-danger">{{ $t(errors[0]) }}</small>
                </validation-provider>
              </b-form-group>
              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password" />
                  <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>{{ $t("Forgot My Password") }}</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="'Password'"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ $t(errors[0]).replaceAll("Password", "Şifre")
                  }}</small>
                </validation-provider>
              </b-form-group>
              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="remembrance"
                  name="checkbox-1"
                >
                  {{ $t("Remember Me") }}
                </b-form-checkbox>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="loginPending"
                :aria-busy="loginPending ? 'true' : 'false'"
              >
                Giriş Yap
              </b-button>
            </b-form>
          </validation-observer>
          <b-card-text class="text-center mt-2">
            <span>Kayıtlı Değil Misin? </span>
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;Hesap Oluştur</span>
            </b-link>
          </b-card-text>
          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">or</div>
          </div> -->
          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from 'bootstrap-vue'
import { isNavigationFailure } from 'vue-router'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import {
  setPhoneSetupHandoff,
  SOURCE_LOGIN_MODERN,
} from '@/auth/phoneSetupHandoff'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      identifier: '',
      remembrance: true,
      loginPending: false,
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    async completeLogin(data) {
      const target = data.isParent
        ? `/parent/${data.children}`
        : this.$route.query.redirect || '/'
      const welcomeName = data.isParent
        ? data.user.name
        : data.user.displayName || data.user.name
      try {
        await this.$router.push(target)
      } catch (error) {
        // A redirected/aborted/duplicated navigation still leaves the session
        // installed, so the login itself succeeded and the welcome toast is
        // still correct. Anything else is a real failure and belongs to the
        // caller's error toast.
        if (!isNavigationFailure(error)) throw error
      }
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `${this.$t('Welcome')} ${welcomeName}`,
          icon: 'CoffeeIcon',
          variant: 'success',
        },
      })
    },
    loginErrorTitle(error) {
      const data = (error && error.response && error.response.data) || {}
      const errorCode = String(data.errorCode || data.code || '')
      if (errorCode === '101101') return this.$t('Wrong Credentials')
      if (error && error.name === 'CredentialStateError') return this.$t('Please reload the page and try again.')
      if (!error || !error.response) return this.$t('Could not reach the server. Please try again.')
      return this.$t('Please reload the page and try again.')
    },
    isRetryableLoginCoordinationError(error) {
      if (!error || error.name === 'CredentialStateError') return false
      if (error.response) return Number(error.response.status) >= 500
      return error.isAxiosError === true && Boolean(error.request || error.code)
    },
    async runLoginCoordinationStage(stage) {
      try {
        return await stage()
      } catch (error) {
        if (!this.isRetryableLoginCoordinationError(error)) throw error
        return stage()
      }
    },
    async validationForm() {
      if (this.loginPending) return
      this.loginPending = true
      try {
        const success = await this.$refs.loginValidation.validate()
        if (!success) return
        const loginPayload = {
          identifier: this.identifier,
          password: this.password,
          remembrance: this.remembrance,
        }
        // Intent creation claims a new cross-tab fence and must never be
        // replayed here: a superseded intent belongs to the newer browser
        // action. Finalization is idempotent for the same intent/grant, so a
        // true transport/server failure may retry that stage once. The
        // credential-bearing prepare stage is never replayed.
        const intent = await useJwt.beginLoginIntent()
        const prepared = await useJwt.prepareLogin(loginPayload, intent)
        if (prepared.data && prepared.data.phoneSetupRequired) {
          // CODE-R4-003: durably promote the shared journal to the
          // approved phone-setup phase before storing the module-local
          // handoff or navigating -- the handoff alone is not
          // cross-tab-ordered and cannot enforce its own continuation
          // deadline.
          await useJwt.promotePhoneSetupIntent(intent.identity, prepared.data.phoneSetupToken)
          setPhoneSetupHandoff({
            token: prepared.data.phoneSetupToken,
            tokenExpiresAt: Date.now()
              + (prepared.data.phoneSetupExpiresInSeconds || 600) * 1000,
            source: SOURCE_LOGIN_MODERN,
            loginIntent: intent,
            returnTo: this.$route.query.redirect || '/',
          })
          await this.$router.push({ name: 'phone-setup' })
          return
        }
        const finalized = await this.runLoginCoordinationStage(() => useJwt.finalizeLogin({
          intent,
          loginGrant: prepared.data && prepared.data.loginGrant,
          loginPayload,
        }))
        await this.completeLogin(finalized.data)
      } catch (error) {
        // The finalize failed only after the server durably committed the
        // login, so the session is live. Reconcile that exact committed
        // authority in place rather than telling the user to reload; if the
        // reconciliation itself fails, report the original error.
        if (error && error.committedLogin) {
          try {
            await useJwt.reconcilePriorLoginCommit(error.committedLogin.watermark)
            await this.completeLogin(error.committedLogin.presentation)
            return
          } catch (recoveryError) {
            // Fall through to the toast for the original error.
          }
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.loginErrorTitle(error),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loginPending = false
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
